export default {
  buttons: {
    change_plan: 'Skift abonnement',
  },
  toasts: {
    failed_to_load_data: 'Kunne ikke indlæse data',
    failed_to_save_changes: 'Kunne ikke gemme ændringer',
  },
};
